import { pageLoadDataParams } from './analytics';

export const defaultPageLoadDataParams = [
  pageLoadDataParams.DIGITAL_PLATFORM,
  pageLoadDataParams.DIGITAL_PLATFORM_COUNTRY,
  pageLoadDataParams.ENVIRONMENT,
];

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum pageLoadDataToAnalytics {
  digitalPlatform = 'digital_platform',
  digitalPlatformCountry = 'digital_platform_country',
  environment = 'environment',
}
